import PropTypes from 'prop-types';
import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';
import ConnectedLoggedInChecker from '../../Login/LoggedInChecker/LoggedInChecker';
import { NotFound } from '../../NotFound/NotFound';
import ConnectedWorkOrder from '../../WorkOrder/WorkOrder';
import { ForemanHeader } from '../Header/ForemanHeader';
import ConnectedForemanHome from '../Home/ForemanHome';
import './ForemanApp.css';
import ConnectedForemanHistory from '../History/ForemanHistory';
import ConnectedEmployeeStats from '../../EmployeeStats/EmployeeStats';
import { Footer } from '../../Footer/Footer';

export const ForemanApp = ({ location }) => (
  <span>
    <ConnectedLoggedInChecker />
    <ForemanHeader location={location.pathname} />
    <Grid className="authenticatedAppGrid" fluid >
      <Row>
        <Col xsOffset={1} xs={10} >
          <Switch>
            <Route exact path="/foreman" component={ConnectedForemanHome} />
            <Route exact path="/foreman/history" component={ConnectedForemanHistory} />
            <Route exact path="/foreman/workorders/:id" component={ConnectedWorkOrder} />
            <Route exact path="/foreman/stats" component={ConnectedEmployeeStats} />
            <Route component={NotFound} />
          </Switch>
        </Col>
      </Row>
      <Row>
        <Footer />
      </Row>
    </Grid>
  </span>);

ForemanApp.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
};

ForemanApp.defaultProps = {
  location: { pathname: '/' },
};



// WEBPACK FOOTER //
// ./src/components/Foreman/ForemanApp/ForemanApp.jsx